import { Component, OnInit,ViewChild } from '@angular/core';
import { GlobalVars } from '../../../providers/globalVars';
import { msgfunc } from '../../../providers/msgfunc';
import { Router,ActivatedRoute } from '@angular/router';
import { AngularFireDatabase} from '@angular/fire/database';
import { AngularFirestore } from '@angular/fire/firestore';
import { ModalController,MenuController,AlertController,ToastController,IonRouterOutlet,IonContent,
NavController,Platform } from '@ionic/angular';
import { AccountPage } from '../account/account.page';
import { NoticePage } from '../notice/notice.page';
import { QnaPage } from '../qna/qna.page';
import { VersionPage } from '../version/version.page';
import { SetnotiPage } from '../setnoti/setnoti.page';
import { WorktoolPage } from '../../custom/worktool/worktool/worktool.page';
import { InvitePage } from '../invite/invite.page';
import { SetlocalPage } from '../../admin/setlocal/setlocal.page';
import { ListUpdatePage } from '../../auth/listupdate/listupdate.page';
import { MailsenderPage } from '../../admin/mailsender/mailsender.page';
import { SystemlogPage } from '../../admin/systemlog/systemlog.page';
//import { SigninPage } from '../../auth/signin/signin.page';
import { TranslateService } from '@ngx-translate/core';
import { AuthData } from '../../../providers/auth-data';
import * as firebase from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';
@Component({
  selector: 'app-pfmenu',
  templateUrl: './pfmenu.page.html',
  styleUrls: ['./pfmenu.page.scss'],
})
export class PfmenuPage implements OnInit {
  @ViewChild(IonContent) content: IonContent;
  notifi:boolean = true;
  mypoint:boolean = true;
  myacti:boolean = true;
  support:boolean = true;
  pitemcount:number = 0;
  useremail:any = 'useremail';
  todaypoint:any = 0;
  emailsent:any;
  sitestr:any="";
  devWidth = this.platform.width();
  showMenu = false;
  constructor(public gv:GlobalVars,public router: Router,private outlet:IonRouterOutlet, private authData: AuthData,
    public alertCtrl: AlertController, public translate: TranslateService,private toastCtrl:ToastController,
    private modalCtrl: ModalController,private afDB: AngularFireDatabase, private afAuth: AngularFireAuth,
  private navCtrl:NavController, public platform: Platform, private msgfunc:msgfunc
    ,private fs:AngularFirestore
  ) { }

  
  ngOnInit() {
    this.outlet.swipeGesture = false; 

    // responsive platform resize
    this.platform.resize.subscribe(async () => {
      this.devWidth = this.platform.width();

      this.responsivActions();
    });
    this.responsivActions();
    // let itemindex = [];
    // let randomNo;
    // while(itemindex.length < 5)
    // {
    //   randomNo = Math.floor(Math.random() * 50);
    //   if(!itemindex.filter(f=>{return f == randomNo}).length)
    //     itemindex.push(randomNo);
    // }
    // console.log(itemindex);
    // firebase.database().ref('/list').orderByChild('createdDate').limitToLast(50).
    // once('value').then(rst=>{
    //   //console.log()
    //   itemindex.forEach(i=>{
    //     console.log(i);
        
    //     console.log(rst.val()[Object.keys(rst.val())[i]].title);
    //   })
      
    // })
    
    // firebase.database().ref('/list').orderByChild('createdDate')
    // .startAt(1572861522863)
    // //.limitToFirst(1)
    // .once('value').then(l=>{
    //   l.forEach(data=>{
    //     // console.log(data.key);
    //     // console.log(data.val())
    //     this.fs.collection('post').doc(data.key).set(data.val()).catch(e=>{
    //       console.log(data.key);
    //       console.log(e);
    //     })
    //   })
    // })

    // firebase.database().ref('/list').orderByChild('createdDate').once('value').then(l=>{
    //   l.forEach(data=>{
    //     this.fs.collection('post').doc(data.key).set(data.val()).catch(e=>{
    //       console.log(data.key);
    //       console.log(e);
    //     })
    //   })
    // })

    //파이어스토어로 list 데이터 이전
    // firebase.database().ref('/category')
    // .once('value').then(l=>{
    //   l.forEach(data=>{
    //     if(data.key.toString().length > 10)
    //       //console.log(data.key)
    //     this.fs.collection('channel').doc(data.key).set(data.val()).catch(e=>{
    //       console.log(data.key);
    //       console.log(e);
    //     })
    //   })
    // })


   
    /* 페이먼트 확인용
    firebase.database().ref('/point').once('value').then(r=>{
      r.forEach(p=>{
        let data = p.val();
        Object.keys(data).forEach(d=>{
          if(data[d].pcode == 'recharge')
            console.log(p.key + '/' + d)
        })
        //if(p.val().pcode == 'recharge')
        //  console.log(p.key)
      })
    })*/

    //NjQizqLkBINRT9LF9oHjmMing403
    // 쿠폰전달

    // let puid;
    // let pitemid = '-MNQtsamZegMJUm0aHWc';
    // let cairnsppl = [];
    // firebase.database().ref('/userProfile').orderByChild('loc').equalTo('cairns').once('value')
    // .then(u=>{
    //   console.log(u.numChildren() + '명')
    //   u.forEach(user=>{
    //     cairnsppl.push({key:user.key, name:user.val().name});
    //     // if(user.key == 'GWJcBZmdATVzY9h3WqBzs0dQbFS2')
    //     // {
    //       // puid = user.key;
    //       // console.log(puid);
    //       // firebase.database().ref('/userData/' + puid + '/pointitem').push({
    //       //   pitemid:pitemid, point:0, createdDate:firebase.database.ServerValue.TIMESTAMP, 
    //       //   used:false, state:'done', order:0,
    //       // }).then(add=>{
    //       //   let lvltxt = '케언즈 유저';
    //       //   if(user.val().sum && user.val().sum.lvl)
    //       //   {
    //       //     this.translate.get('Level'+user.val().sum.lvl).subscribe(res=>{
    //       //     lvltxt = res;
    //       //     });
    //       //   }
    //       //   firebase.database().ref('/pmalldata/' + pitemid + '/' + add.key).set({
    //       //   uid:user.key, createdDate:firebase.database.ServerValue.TIMESTAMP, used:false, title:lvltxt
    //       //   })
    //       //   console.log(puid + '전달됨..');
    //       //   this.msgfunc.sendnotionly('한인 미용실 엘르에서 $10불 할인쿠폰을 보냈습니다.','쿠폰이 도착하였습니다.','한인 미용실 엘르에서 $10불 할인쿠폰을 보냈습니다.', 'pitem',pitemid,puid);
    //       // })
    //     //  }
    //     // {
    //     //   firebase.database().ref('/userData/' + user.key + '/pointitem').orderByChild('pitemid').equalTo(pitemid).once('value').then(p=>{
    //     //     p.forEach(pp=>{
    //     //       //console.log(pp.key)
    //     //       firebase.database().ref('/pmalldata/' + pitemid + '/' + pp.key).update({uid:user.key})
    //     //     })
    //     //   })
    //     // }
    //   })
    // }).then(_=>{
    //   console.log(cairnsppl);
    //   let index = 0;
    //   let si = setInterval(_=>{
    //     console.log(cairnsppl[index].name + '전달됨..');
    //     this.msgfunc.sendnotionly('한인 미용실 엘르에서 $10불 할인쿠폰을 보냈습니다.','쿠폰이 도착하였습니다.','한인 미용실 엘르에서 $10불 할인쿠폰을 보냈습니다.', 'pitem',pitemid,cairnsppl[index].key);
    //     index++;
    //     if(index == cairnsppl.length) clearInterval(si);
    //   },300)
    // })
    

    /*
    let puid;// = '';
    let pitemid = '-M2qgxhHe4Q-oIRhDiD6';
    firebase.database().ref('/userProfile').orderByChild('loc').equalTo('cairns').once('value').then(u=>{
      u.forEach(user=>{
        if(user.key != 'GWJcBZmdATVzY9h3WqBzs0dQbFS2')
        {
        puid = user.key;
        firebase.database().ref('/userData/' + puid + '/pointitem').push({
          pitemid:pitemid, point:0, createdDate:firebase.database.ServerValue.TIMESTAMP, 
          used:false, state:'done', order:0,
        }).then(add=>{
          let lvltxt = '케언즈 유저';
          if(user.val().sum && user.val().sum.lvl)
          {
            this.translate.get('Level'+user.val().sum.lvl).subscribe(res=>{
            lvltxt = res;
            });
          }
          firebase.database().ref('/pmalldata/' + pitemid + '/' + add.key).set({
          uid:user.key, createdDate:firebase.database.ServerValue.TIMESTAMP, used:false, title:lvltxt
          })
          console.log(puid + '전달됨..');
        })
        }
      })
    })*/
    

    /* 쿠폰 직접전달
    let puid = 'STwZl15ptZcS7xEVW2En1gIQNFH2';
    let pitemid = '-M2qgxhHe4Q-oIRhDiD6';
    firebase.database().ref('/userProfile/' + puid).once('value').then(u=>{
      
        //puid = user.key;
        firebase.database().ref('/userData/' + puid + '/pointitem').push({
          pitemid:pitemid, point:0, createdDate:firebase.database.ServerValue.TIMESTAMP, 
          used:false, state:'done', order:0,
        }).then(add=>{
          let lvltxt = '케언즈 유저';
          if(u.val().sum && u.val().sum.lvl)
          {
            this.translate.get('Level'+u.val().sum.lvl).subscribe(res=>{
            lvltxt = res;
            });
          }
          firebase.database().ref('/pmalldata/' + pitemid + '/' + add.key).set({
          uid:puid, createdDate:firebase.database.ServerValue.TIMESTAMP, used:false, title:lvltxt
          })
          console.log(puid + '전달됨..');
        
      })
    })*/
    
    /*
    this.afDB.database.ref('/userData').once('value').then(rst=>{
      rst.forEach(r=>{
        let fav = r.val().favlist;
        if(fav)
        {
          Object.keys(fav).forEach(f=>{
            this.afDB.database.ref('/category/'+fav[f].chid).once('value').then(c=>{
              if(!c.val() || !c.val().name)
                console.log('여기 문제!!!!!!!!!!!!/'+f+'/'+r.key+'/'+c.key)
            })
          })
        }
      })
    })*/
    /*this.afDB.database.ref('/category').once('value').then(rst=>{
      rst.forEach(r=>{
        if(r.val().name && r.val().loc && !r.val().imagethumb){
          this.afDB.database.ref('/category/'+r.key).update({imagethumb:[{url:''}]})
          console.log(r.key);
          console.log(r.val())
        }
      })
    })*/
    /*
    this.afDB.database.ref('/userProfile').orderByChild('createdDate').once('value').then(u=>{
      u.forEach(user=>{
        if(user.val().totalcount && user.val().totalcount.point < 0)
        {
          console.log(user.key)
          console.log(user.val().nickname);
          console.log(user.val().totalcount);

        }
      })
    })*/
    /*
    this.afDB.database.ref('/event/NewYearRoulette2').once('value').then(rst=>{
      rst.forEach(r=>{
        this.afDB.database.ref('/userProfile/'+r.val().uid+'/nickname').once('value').then(a=>{
          console.log(a.val() + '님 ' + r.val().prize);
        })
      })
    })*/
    /*룰렛이벤트삭제
    this.afDB.database.ref('/point/loGz8mya8gN9P7t5XWyhnzP8n4v2').limitToLast(600).once('value').then(rst=>{
      rst.forEach(r=>{
        let pcode = r.val().pcode;
        if(pcode.indexOf('쿠폰')>-1)
          this.afDB.database.ref('/point/loGz8mya8gN9P7t5XWyhnzP8n4v2/'+r.key).remove();
        else if(pcode.indexOf('룰렛')>-1)
          this.afDB.database.ref('/point/loGz8mya8gN9P7t5XWyhnzP8n4v2/'+r.key).remove();
      })
    })*/

    // let sitemaparray = [];
    // this.afDB.database.ref('/category').orderByChild('createdDate').startAt(new Date('2020-03-17T00:36:33.408Z').getTime()).once('value').then(cat=>{
    //   cat.forEach(c=>{
    //     if(c.val().createdDate && c.val().publiccommunity)
    //       sitemaparray.unshift("<url><loc>https://channel.cafe/tabs/home/chmain/"+c.key+"</loc><lastmod>"+new Date(c.val().createdDate).toISOString()+"</lastmod></url>")
    //   })
    // }).then(_=>{
    //   this.afDB.database.ref('/list').orderByChild('createdDate').startAt(new Date('2020-03-20T00:16:03.465Z').getTime()).once('value').then(item=>{
    //     item.forEach(i=>{
    //     if(i.val().createdDate && !i.val().private)
    //       sitemaparray.unshift("<url><loc>https://channel.cafe/tabs/home/chview/"+i.key+"</loc><lastmod>"+new Date(i.val().createdDate).toISOString()+"</lastmod></url>")
    //     })
    //   })
    // }).then(_=>{

    //   setTimeout(_=>{
    //     sitemaparray.forEach(a=>{
    //       this.sitestr += a + '\r\n';
    //     })

    //   },5000)
    // })


    /* 모든유저 fcm 갱신
    if(this.gv.uid)
    firebase.database().ref('/userData').once('value').then(rst=>{
      rst.forEach(u=>{
        console.log(u.key);
        firebase.database().ref('/userData/' + u.key + '/state').update({fcmreloadrequired:true})
      })
    })*/
  }
  ionViewDidEnter(){this.gv.selectedcontent = this.content;}
  ionViewWillLeave() {this.gv.selectedcontent = null;}
  ionViewDidLeave(){this.outlet.swipeGesture = true;}
  ionViewWillEnter(){
    if (this.gv.uid) {
      this.afDB.database.ref('/userProfile/' + this.gv.uid + '/email').once('value').then(email => {
        if (email.val()) this.useremail = email.val();
      });
      if(!this.gv.uvf)
      {
        if(firebase.auth().currentUser.emailVerified)
           firebase.database().ref('/userProfile/' + this.gv.uid).update({uvf:true})
      } 
      this.afDB.database.ref('/userData/' + this.gv.uid + '/mybucket').once('value').then(mybucket => {
        this.gv.umybucket = mybucket.val();
      })
      this.afDB.database.ref('/userData/' + this.gv.uid + '/pointitem').once('value').then(pi => {
        this.pitemcount = 0;
        if (pi.val()) {
          pi.forEach(p => {
            if (!p.val().used) {
              this.pitemcount++;
            }
          })
        }
      })
      this.afDB.database.ref('/userProfile/' + this.gv.uid + '/totalcount').once('value').then(total => {
        this.gv.utotal = total.val();
      })

      // gettoday(){ 
      let today = new Date();
      this.afDB.database.ref('/point/'+this.gv.uid).orderByChild('createdDate')
      .startAt(today.getTime()-(1000*60*60*24)).once('value').then(pt=>{
        this.todaypoint = 0;
        let todaystr = today.toLocaleDateString();
        // console.log(Object.keys(pt.val()).length + '개항목')
        pt.forEach(p=>{
          if((p.val().point > 0) && 
            (todaystr == new Date(p.val().createdDate).toLocaleDateString())
            )
            this.todaypoint += p.val().point;
        })
      });
      // }

    }
  }
  responsivActions() {
    if( this.devWidth >= 992 ) {
      this.showMenu = true;
    } else {
      this.showMenu = false;
    }
  }

  passHanCoupon(){
    this.alertCtrl.create({
    message: '<h6>Email address for Coupon</h6>',
    inputs:[{name:'email',type:'email'}],
    buttons: [
        {
        text: '취소',
        },
        {
        text: '전달',
        handler: (data) => {
          //하나원 쿠폰전달 프로시져
          let puid;
          let pitemid = '-M2afNXL1Ihpg-7qirjQ';
          firebase.database().ref('/userProfile').orderByChild('email').equalTo(data.email).once('value').then(u=>{
            if(u.numChildren() == 1)
            {
            u.forEach(userraw=>{
              let user;
              user = userraw.val();
              puid = userraw.key;
              firebase.database().ref('/userData/' + puid + '/pointitem').push({
                pitemid:pitemid, point:0, createdDate:firebase.database.ServerValue.TIMESTAMP, 
                used:false, state:'done', order:0,
              }).then(add=>{
                let lvltxt = 'Hanawon Member';
                // if(user.sum && user.sum.lvl)
                // {
                //   this.translate.get('Level'+user.sum.lvl).subscribe(res=>{
                //   lvltxt = res;
                //   });
                // }
                firebase.database().ref('/pmalldata/' + pitemid + '/' + add.key).set({
                uid:puid, createdDate:firebase.database.ServerValue.TIMESTAMP, used:false, title:lvltxt
                })
                this.presentToast('[전달 완료]<br>해당 이메일로 전달 완료하였습니다.');
              })
              
            })
            }
            else{
              this.presentToast('[전달 실패]<br>이메일이 없거나 여러개입니다.');
            }
          })
        }
        }
    ]
    }).then(_=>_.present())
  }

  async openpage(page){
    let type = null;
    let log = null;
    let prop; //{modal:true, type:null};log = 'actchk'; 
    prop = {modal:true, type:null};
    switch(page){
      // case 'pointinfo':this.router.navigate(['/tabs/pfmenu/pointinfo']); break;
      // case 'mypoint':this.router.navigate(['/tabs/pfmenu/mypoint'], {relativeTo: this.activeRouter}); break;
      // case 'mypitem':this.router.navigate(['/tabs/pfmenu/mypitem']); break;
      // case 'msg':this.router.navigate(['/tabs/pfmenu/message']); break;
      // case 'alarm':this.router.navigate(['/tabs/pfmenu/alarm']); break;
      // case 'favchlist':this.router.navigate(['/tabs/pfmenu/favchlist']); log = 'actchk'; break;
      // case 'actrecent':this.router.navigate(['/tabs/pfmenu/listmodal','r']); log = 'actchk'; break;
      // case 'actpost':this.router.navigate(['/tabs/pfmenu/listmodal','w']); log = 'actchk'; break;
      // case 'actliked':this.router.navigate(['/tabs/pfmenu/listmodal','l']); log = 'actchk'; break;
      // case 'actcomment':this.router.navigate(['/tabs/pfmenu/listmodal','c']); log = 'actchk'; break;
      // case 'mybucket':this.router.navigate(['/tabs/pfmenu/mybucket']); log = 'actchk'; break;
      // case 'inquiry':this.router.navigate(['/tabs/pfmenu/inquiry']); break;
      // this.router.navigate(['/tabs/pfmenu/mylevel']);  log = 'levelchk'; break;

      case 'pointinfo':this.navCtrl.navigateForward('/tabs/pfmenu/pointinfo'); break;
      case 'mypoint':this.navCtrl.navigateForward('/tabs/pfmenu/mypoint'); break;
      case 'mypitem':this.navCtrl.navigateForward('/tabs/pfmenu/mypitem'); break;
      case 'msg':this.navCtrl.navigateForward('/tabs/pfmenu/message'); break;
      case 'alarm':this.navCtrl.navigateForward('/tabs/pfmenu/alarm'); break;
      case 'favchlist':this.navCtrl.navigateForward('/tabs/pfmenu/favchlist'); log = 'actchk'; break;
      case 'actrecent':this.navCtrl.navigateForward(['/tabs/pfmenu/listmodal','r']); log = 'actchk'; break;
      case 'actpost':this.navCtrl.navigateForward(['/tabs/pfmenu/listmodal','w']); log = 'actchk'; break;
      case 'actliked':this.navCtrl.navigateForward(['/tabs/pfmenu/listmodal','l']); log = 'actchk'; break;
      case 'actcomment':this.navCtrl.navigateForward(['/tabs/pfmenu/listmodal','c']); log = 'actchk'; break;
      case 'mybucket':this.navCtrl.navigateForward('/tabs/pfmenu/mybucket'); log = 'actchk'; break;
      case 'inquiry':this.navCtrl.navigateForward('/tabs/pfmenu/inquiry'); break;
      case 'mylevel':this.navCtrl.navigateForward('/tabs/pfmenu/mylevel'); break;
      //case 'nickname':this.router.navigate(['/nickname']); break;
      //case 'blockuser':this.router.navigate(['/blockuser']); break;
      //case 'pwdchange':this.router.navigate(['/pwdchange']); break;
      case 'listup':this.modalCtrl.create({
                  component: ListUpdatePage,
                  componentProps:<null>prop,
                  cssClass: 'modalfull'
                }).then(_=>_.present()); ; break;

      case 'setnoti':
                    if( this.gv.uid){
                      this.modalCtrl.create({
                        component: SetnotiPage,
                        componentProps:<null>prop,
                        cssClass: 'modalfull'
                      }).then(_=>_.present()); log = 'alarmchk'; break;}
                    else if(!this.gv.uid)
                      {
                        this.presentToast('설정을 위해 로그인 해주세요.'); break;;
                      }
                    else{
                      this.presentToast('알림설정은 앱을 통해 해주세요.'); break;;
                    }
      case 'notice':this.modalCtrl.create({
                        component: NoticePage,
                        componentProps:<null>prop,
                        cssClass: 'modalfull'
                      }).then(_=>_.present()); log = 'noticechk'; break;
      case 'qna':this.modalCtrl.create({
                        component: QnaPage,
                        componentProps:<null>prop,
                        cssClass: 'modalfull'
                      }).then(_=>_.present()); log = 'qnachk'; break;
      case 'version':this.modalCtrl.create({
                        component: VersionPage,
                        componentProps:<null>prop,
                        cssClass: 'modalfull'
                      }).then(_=>_.present()); break; 
      case 'myaccount':this.modalCtrl.create({
                        component: AccountPage,
                        componentProps:<null>prop,//{modal:true, type:type},
                        cssClass: 'modalfull'
                        // swipeToClose: true,
                        // presentingElement: await this.modalCtrl.getTop()
                      }).then(_=>_.present()); break;
      case 'setlocal':this.modalCtrl.create({
                        component: SetlocalPage,
                        componentProps:<null>prop,
                        cssClass: 'modalfull'
                      }).then(_=>_.present()); break;
      case 'systemlog':this.modalCtrl.create({
                        component: SystemlogPage,
                        componentProps:<null>prop,
                        cssClass: 'modalfull'
                      }).then(_=>_.present()); break;
      case 'invite':this.modalCtrl.create({
                        component: InvitePage,
                        componentProps:<null>prop,
                        cssClass: 'modalfull'
                      }).then(_=>_.present()); break;
      case 'mailsender':this.modalCtrl.create({
                        component: MailsenderPage,
                        componentProps:<null>prop,
                        cssClass: 'modalfull'
                      }).then(_=>_.present()); break;
      }
    if(log)
    {
    let today = new Date();
    let todaystr = today.getFullYear() + '-' + (today.getMonth()+1>9?today.getMonth()+1:'0' + (today.getMonth()+1)) + '-' + (today.getDate()>9?today.getDate():'0'+today.getDate())
    this.afDB.database.ref('/systemlog/' + (this.gv.uid?this.gv.uid:'unregister') + '/event/' + todaystr + '/' + log).transaction(view=>{
      return (view || 0) + 1;
    })
    }
  }
  async showwork(){    
    const modal = await this.modalCtrl.create({
      component: WorktoolPage,
      cssClass: 'modalfull'
    });
    return await modal.present();
  }

  sendverification(){
    this.emailsent = 'sending';
    firebase.auth().currentUser.sendEmailVerification().then(_=> {
      this.emailsent = 'done';
      let sentmsg;
      this.translate.get('Confirm email has sent.').subscribe(res=>{
      sentmsg = res;
      });
      this.presentToast(sentmsg);
    }, e=> {
      this.emailsent = 'failed';
      let failedmsg;
      this.translate.get('Failed to send confirm email.<br>Please try it 5 mins later.').subscribe(res=>{
      failedmsg = res;
      });
    this.presentToast(failedmsg);
    });
  }

  async renenduvf(){
    let resendmsg,cancel,resend;
    this.translate.get('Already sent confirm email.<br>Would you like send it again?').subscribe(res=>{
    resendmsg = res;
    });
    this.translate.get('Cancel').subscribe(res=>{cancel=res})
    this.translate.get('Re-send').subscribe(res=>{resend=res})
    let alert = await this.alertCtrl.create({
    message: '<h6>'+resendmsg+'</h6>',
    buttons: [
        {
        text: cancel,
        },
        {
        text: resend,
        handler: () => {
          this.sendverification();
        }
        }
    ]
    });
    return await alert.present();
  }

  async faileduvf(){
    let faileddmsg,cancel,resend,ask;
    this.translate.get("You have failed to received confirm email.<br>Please re-send it or use '1:1 Ask.").subscribe(res=>{
    faileddmsg = res;
    });
    this.translate.get('Cancel').subscribe(res=>{cancel=res})
    this.translate.get('Re-send').subscribe(res=>{resend=res})
    this.translate.get('Ask').subscribe(res=>{ask=res})
    let alert = await this.alertCtrl.create({
    message: '<h6>'+faileddmsg+'</h6>',
    buttons: [
        {
        text: cancel,
        },
        {
        text: resend,
        handler: () => {
          this.sendverification();
        }
        },
        {
        text: ask,
        handler: () => {
          this.openpage('inquiry');
        }
        }
    ]
    });
    return await alert.present();
  }

  chkuvf(){
    firebase.auth().currentUser.reload().then(_=>{
      if(firebase.auth().currentUser.emailVerified)
      {
        //console.log(firebase.auth().currentUser.emailVerified)  
        firebase.database().ref('/userProfile/' + this.gv.uid).update({uvf:true})
        this.gv.uvf = true;
        let vf,pointpaid;
        this.translate.get('Email has verified.').subscribe(res=>{vf=res})
        this.translate.get('Your recommender received invite points.').subscribe(res=>{pointpaid=res})
        this.presentToast(vf);
        firebase.database().ref('/userProfile/' + this.gv.uid + '/recommended').once('value').then(rc=>{
          if(rc.val())
          {
            let recuserid;
            firebase.database().ref('/userProfile').orderByChild('nicknamelower').equalTo(rc.val().toLowerCase().replace(/ /g, '')).once('value').then(
            recuser=>{
              recuser.forEach(element => {
                recuserid = element.key;
              })
              firebase.database().ref('/point/' + recuserid).push({pcode:'getrec', point:100, nickname:rc.val(), recuid:this.gv.uid,
              createdDate:firebase.database.ServerValue.TIMESTAMP}).then(_=>{this.presentToast(pointpaid);});
            })
          }
        })
      }
      else{
        let notyet;
        this.translate.get("Email hasn't verified yet.").subscribe(res=>{notyet=res})
        this.presentToast(notyet);
      }
    });
    
  }

  set(lan){
    this.gv.setLan(lan);
    if(this.gv.uid)
      firebase.database().ref('/userProfile/' + this.gv.uid).update({lan:lan});
  }

  gglogin(){this.authData.gglogin()};
  fblogin(){this.authData.fblogin()};


  async signout(menu){
    var signoutmsg, cancelbtn, signoutbtn;
   
    this.translate.get('areyousuretosignout').subscribe(res=>{
    signoutmsg = res;
    });
    this.translate.get('Cancel').subscribe(res=>{
    cancelbtn = res;
    });
    this.translate.get('Confirm').subscribe(res=>{
    signoutbtn = res;
    });
    
    let alert = await this.alertCtrl.create({
    message: signoutmsg,
    buttons: [
        {
        text: cancelbtn,
        },
        {
        text: signoutbtn,
        handler: () => {
          menu.close();
          this.authData.logoutUser().then(_=>{
            this.authData.clearnoti();
            
            //this.router.navigate(['signin']);
          });
        }
        }
    ]
    });
    return await alert.present();
  }

   async presentToast(message: string) {
    let toast = await this.toastCtrl.create({
    message: message,
    position: 'bottom',
    duration: 2500
    });
    toast.present();
    }



    /* 모든유저 fcm 갱신
    firebase.database().ref('/userData').once('value').then(rst=>{
      rst.forEach(u=>{
        console.log(u.key);
        firebase.database().ref('/userData/' + u.key + '/state').update({fcmreloadrequired:true})
      })
    })*/
    
     // 이하 사용자 글작성한것 chid가져오는 함수
     /*
    firebase.database().ref('/userProfile').once('value').then(rst=>{
      rst.forEach(r=>{
        if(r.val() && r.val().write)
          {
            let data = r.val().write;
            for(let i = 0; i < Object.keys(data).length; i++)
              {              
                let id = data[Object.keys(data)[i]].itemid;
                firebase.database().ref('/list/' + id).once('value').then(li=>{
                  if(li.val() && li.val().categoryId)
                  {
                    firebase.database().ref('/userProfile/' + r.key + '/write/' + Object.keys(data)[i]).update({chid:li.val().categoryId})
//                    console.log(r.key + ']' + Object.keys(data)[i] + " : " + li.val().title + ' : ' + li.val().categoryId)
                  }
                })
              }
          }
      })
    })*/

}
